import { css } from '@emotion/react'
import { ButtonHTMLAttributes, memo } from 'react'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import shape from '../styles/shape'
import Button from './Button'

const iconButtonStyles = css({
    padding: getThemeSpacing(0.75),
    display: 'flex',
    flexFlow: 'column nowrap',
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    fontSize: 8,
    color: palette.buttonBackground,
    borderRadius: '50%',
    lineHeight: 'normal',
    '&:disabled svg': {
        fill: palette.disabledIcons,
        color: palette.disabledIcons,
    },
    '&:disabled': {
        color: palette.buttonBorder,
        background: 'transparent',
    },
})

const labelStyles = css({
    borderRadius: shape.borderRadiusMedium,
})

const dimStyles = css({
    color: palette.greyMFC,
    '& svg': {
        color: palette.dimContrastIcons,
    },
})

const noVerticalPadding = css({
    padding: `0 ${getThemeSpacing(0.5)}`,
})
export interface IconButtonProps
    extends ButtonHTMLAttributes<HTMLButtonElement> {
    ref?: any
    children?: any
    dim?: boolean
    showLabel?: boolean
    zeroVerticalPadding?: boolean
}

const IconButton = (props: IconButtonProps) => {
    const {
        ref,
        children,
        className,
        dim = false,
        showLabel = false,
        zeroVerticalPadding = false,
        ...rest
    } = props

    return (
        <Button
            ref={ref}
            clean
            size="small"
            disableElevation
            className={`icon-button ${className ?? ''}`}
            css={[
                iconButtonStyles,
                showLabel ? labelStyles : null,
                zeroVerticalPadding ? noVerticalPadding : null,
                dim ? dimStyles : null,
            ]}
            {...rest}
        >
            {children}
        </Button>
    )
}

export default memo(IconButton)
